import { useRef } from 'react';
import { CasesBoardGroup } from '@lp/features/CasesBoard/components/CasesBoardGroup';
import { CasesBoardNavigationChips } from '@lp/features/CasesBoard/components/CasesBoardNavigationChips';
import { useCasesBoardSubscription } from '@/hooks/useCasesBoardSubscription';
import { useCasesBoardStore } from '@/store/cases-board.store';
import { caseStatusNames } from '@/constants/case/case.constants';
import { useCasesBoardDeviceTracking } from './hooks/useCasesBoardDeviceTracking';
import { useCasesBoardRowVisibility } from './hooks/useCasesBoardRowVisibility';
import styles from './CasesBoard.module.scss';

export const CasesBoard = () => {
  const boardContainerRef = useRef<HTMLDivElement>(null);
  const statusColsRefs = useRef(new Map<string, HTMLDivElement | null>([]));

  const isRows = useCasesBoardStore((state) => state.isRows);
  const statusesOrdered = useCasesBoardStore((state) => state.statusesOrdered);
  const groupsOrdered = useCasesBoardStore((state) => state.groupsOrdered);
  const showGroups = useCasesBoardStore((state) => state.showGroups);

  useCasesBoardDeviceTracking();
  useCasesBoardSubscription();

  const { shouldRenderStatus, shouldRenderGroup } = useCasesBoardRowVisibility();

  const onChipClick = (id: string) => {
    const el = statusColsRefs.current.get(id);
    if (!el) return;

    boardContainerRef.current?.scrollTo({
      [isRows ? 'top' : 'left']: isRows ? el.offsetTop : el.offsetLeft,
      behavior: 'instant',
    });
  };

  return (
    <>
      <CasesBoardNavigationChips onChipClick={onChipClick} />
      <div className={styles.container} ref={boardContainerRef}>
        <div className={isRows ? styles.boardRows : styles.boardColumns}>
          {showGroups
            ? groupsOrdered.filter(shouldRenderGroup).map((g) => (
                <CasesBoardGroup
                  key={g.id}
                  isRows={isRows}
                  title={g.name}
                  group={g}
                  ref={(el) => {
                    statusColsRefs.current.set(g.id, el);
                  }}
                />
              ))
            : statusesOrdered.filter(shouldRenderStatus).map((status) => (
                <CasesBoardGroup
                  key={status}
                  isRows={isRows}
                  title={caseStatusNames[status]}
                  status={status}
                  ref={(el) => {
                    statusColsRefs.current.set(status, el);
                  }}
                />
              ))}
        </div>
      </div>
    </>
  );
};
